import { getHook, setHook } from "react-hooks-outside";
import { useAuth } from "@xemplo/auth-provider";

setHook("useAuth", useAuth);

export const getAccessToken = async () => {
  const hook = getHook("useAuth");
  return await hook.getAccessToken();
};
